/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Harden_Output6Inputs */

const en_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch runbook`)
};

const ar_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دليل الإطلاق`)
};

const bn_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লঞ্চ রানবুক`)
};

const de_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch-Runbook`)
};

const es_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual de lanzamiento`)
};

const fr_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manuel de lancement`)
};

const pt_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual de lançamento`)
};

const zh_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上线手册`)
};

const tr_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansman el kitabı`)
};

const ru_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство запуска`)
};

const pl_svc_ai_app_rescue_harden_output6 = /** @type {(inputs: Svc_Ai_App_Rescue_Harden_Output6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podręcznik startu`)
};

/**
* | output |
* | --- |
* | "Launch runbook" |
*
* @param {Svc_Ai_App_Rescue_Harden_Output6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_harden_output6 = /** @type {((inputs?: Svc_Ai_App_Rescue_Harden_Output6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Harden_Output6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_harden_output6(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_harden_output6(inputs)
	return en_svc_ai_app_rescue_harden_output6(inputs)
});
export { svc_ai_app_rescue_harden_output6 as "svc_ai-app-rescue_HARDEN_output" }